<script setup lang="ts">
import SegmentForm from '@/features/matching/components/segments/SegmentForm.vue'
import { useRouter } from 'vue-router'

definePage({
  path: '/matching/segments/:id',
  name: '/matching/SegmentDetail',
  meta: {
    title: 'Segment',
    breadcrumbParent: '/matching/Segments',
  },
})

const router = useRouter()
const route = useRoute('/matching/SegmentDetail')

const segmentId = computed(() => {
  const raw = (route.params as { id: string }).id

  return raw === 'new' ? null : Number(raw)
})

function close() {
  router.push({ name: '/matching/Segments' })
}

function saved(id: number) {
  router.push({
    name: '/matching/SegmentDetail',
    params: { id: String(id) },
  })
}
</script>

<template>
  <SegmentForm
    :segment-id="segmentId"
    :show-header="true"
    :show-cancel-button="true"
    @cancel="close"
    @saved="saved"
  />
</template>
